import { Box, Grid } from "@material-ui/core";
import PeopleAltRoundedIcon from "@material-ui/icons/PeopleAltRounded";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import { Fragment } from "react";
import { AmlStatuses, ApplicationDto, KiwiSaverApplicationDto, Product } from "../../../api/apiClients";
import { getClientDisplayName } from "../../../common/helpers";
import { Colors, SubtitleText } from "../../controls/helpers";
import { sortApplicationClients } from "../Helpers";
import { Details, Section } from "../Section";
import { ApplicationAmlStatus } from "../StatusChips";

const ProductAccounts = ({ accounts, product, isRetention }: { accounts: ApplicationDto[]; product: Product; isRetention?: boolean }) => {
  let productName = "";
  switch (product) {
    case Product.KiwiSaver:
      productName = "KiwiSaver";
      break;
    case Product.WealthBuilder:
      productName = "Wealth Builder";
      break;
    case Product.IncomeGenerator:
      productName = "Income Generator";
      break;
  }

  return (
    <>
      {" "}
      {accounts.map((account, index) => {
        const sortedApplicationClients = sortApplicationClients(account.applicationClients || []);

        return (
          !!sortedApplicationClients.length && (
            <Fragment key={`account${index}`}>
              <Grid item xs={12}>
                <Section hideTopBorder>
                  <Details>
                    <SubtitleText black hideMarginBottom>
                      <b>{productName}</b>
                      {isRetention && <>&emsp;{(account as KiwiSaverApplicationDto).accountKey}</>}
                    </SubtitleText>
                    <Box display="flex" flexGrow={1} justifyContent="flex-end">
                      {sortedApplicationClients.length > 1 ? <PeopleAltRoundedIcon htmlColor={Colors.Blue} /> : <PersonRoundedIcon htmlColor={Colors.Blue} />}
                    </Box>
                  </Details>
                </Section>
              </Grid>
              {sortedApplicationClients.map((client, i) => (
                <Grid item xs={12} key={`client${i}`}>
                  <Section hideTopBorder hideBottomBorder={i + 1 === sortedApplicationClients.length}>
                    <Details title={getClientDisplayName(client)}>
                      <ApplicationAmlStatus
                        title="Appl/AML"
                        isRetention={product === Product.KiwiSaver && isRetention}
                        adviceStatus={client.adviceStatus!}
                        clientStatus={client.clientStatus}
                        amlStatus={product === Product.KiwiSaver && client.ipFailed === false && client.cloudCheckFailed === false ? AmlStatuses.Successful : client.amlStatus!}
                        style={{ marginRight: 0 }}
                      />
                    </Details>
                    {i + 1 === sortedApplicationClients.length && <br />}
                  </Section>
                </Grid>
              ))}
            </Fragment>
          )
        );
      })}{" "}
    </>
  );
};

export default ProductAccounts;
